import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
import * as React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';
function Literals(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? colors.neutral700 : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85 12 10 24H8.012l-.896-2.794H2.869L1.98 24H0l4.142-12H5.85Zm11.734 1.652.909.927-4.131 4.214 2.008.002v1.302h-4.202v-4.273h1.29l.002 2.035 4.124-4.207ZM5 14.182l-1.667 5.454h3.334L5 14.182ZM19.842 0c1.268 0 2.233.272 2.895.816.662.544.994 1.354.994 2.431 0 .55-.14 1.044-.416 1.484-.277.44-.683.78-1.217 1.022.606.176 1.074.507 1.405.993.331.486.497 1.07.497 1.751 0 1.127-.337 1.992-1.012 2.596-.675.605-1.642.907-2.9.907H16V0h3.842Zm-6.799 3.903v4.273h-1.29l-.001-2.035-4.125 4.207-.908-.927 4.13-4.214-2.008-.002V3.903h4.202Zm7.23 2.682h-2.325v3.75h2.164c.61 0 1.088-.162 1.432-.486.344-.324.516-.775.516-1.352 0-1.247-.596-1.884-1.787-1.912Zm-.43-4.904h-1.895v3.371h1.91c.605 0 1.079-.147 1.42-.44.341-.295.512-.71.512-1.25 0-.593-.158-1.021-.473-1.285-.316-.264-.808-.396-1.475-.396Z",
    fill: color
  }));
}
export default Literals;